export default __webpack_public_path__ + "static/media/total-patients.e505dced.svg";